<template>
  <keep-alive>
    <div>
      <slot :errors="errors"></slot>
    </div>
  </keep-alive>
</template>

<script>
import {computed, inject} from 'vue';

export default {
  name: 'ErrorWrapper',
  props: {
    group: {
      type: String,
    },
  },
  setup(props) {
    const node = inject('node');
    const errors = computed(() => node.errors.get(props.group));

    return {
      node,
      errors,
    };
  },
};
</script>
